import React from 'react'
import styled from 'styled-components/native'
import { atlTheme } from '../../../atlTheme'
import { formatMessage } from '../../../constants/strings/intl/intlHooks'
import { messages } from '../../../constants/strings/messages'
import { ATLSpacing, ATLTextHead, SpacingSizesEnum, TextAlignmentEnum } from '@appsimples/atlantica-react-native'
import { Container } from '../ItemContainer'

const TopContainer = styled.View`
  margin-top: ${atlTheme.SpacingAtomic}px;
  border-bottom-start-radius: ${atlTheme.BorderRadiusCard}px;
  border-bottom-end-radius: ${atlTheme.BorderRadiusCard}px;
  background: ${atlTheme.ColorSurface};
  width: 100%;
`
const MainText = styled.Text`
  font-family: ${atlTheme.FontFamilyBrand};
  font-weight: normal;
  font-size: ${atlTheme.FontSizeBody}px;
  line-height: ${atlTheme.LineHeightBase}px;
  color: ${atlTheme.ColorHighContrast};
  padding: ${atlTheme.SpacingBase}px ${atlTheme.SpacingMarginal}px;
`

export const AboutBrio: React.FunctionComponent = () => {
  return (
    <>
      <TopContainer>
        <MainText>{formatMessage(messages.profileScreen_aboutBrio_fullText)}</MainText>
        <ATLSpacing type={SpacingSizesEnum.marginal} />
      </TopContainer>
      <Container>
        <ATLTextHead textAlignment={TextAlignmentEnum.left}>
          {formatMessage(messages.profileScreen_aboutBrio_visionTitle)}
        </ATLTextHead>
        <MainText>{formatMessage(messages.profileScreen_aboutBrio_vision)}</MainText>
      </Container>
      <Container>
        <ATLTextHead textAlignment={TextAlignmentEnum.left}>
          {formatMessage(messages.profileScreen_aboutBrio_missionTitle)}
        </ATLTextHead>
        <MainText>{formatMessage(messages.profileScreen_aboutBrio_mission)}</MainText>
      </Container>
      <Container>
        <ATLTextHead textAlignment={TextAlignmentEnum.left}>
          {formatMessage(messages.profileScreen_aboutBrio_valuesTitle)}
        </ATLTextHead>
        <MainText>{formatMessage(messages.profileScreen_aboutBrio_values)}</MainText>
      </Container>
    </>
  )
}
